import { useParams } from "react-router";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";
import { DataNews_1 } from "../../inc/DataNews";
import { DataAnimal } from "../../inc/DataAnimal";

const newsComponents = {
  1: DataNews_1,
  2: DataAnimal,
};

export default function Page() {
  const { id } = useParams();
  const Component = newsComponents[id];
  return (
    <>
      <Navbar />
      <DropdownMenu />
      <div className="relative">
        <div className="max-w-5xl mx-auto container h-full">
          {Component ? <Component /> : <span>ไม่พบข้อมูล</span>}
        </div>
      </div>
      <Footer />
    </>
  );
}
